import * as Yup from 'yup';

const loginFormValidationScheme = Yup.object().shape({
	email: Yup.string().email('Email address is invalid.').required('This field is required.'),
	password: Yup.string().required('This field is required.'),
});

export default loginFormValidationScheme;
